/* eslint-disable react/forbid-prop-types */
import React from 'react';
import moment from 'moment';
import { Row, Col, Card, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import AreaBarGraph from './AreaBarGraph';

const SalesBreakDownCategorised = ({ dir, dataToShowForDatesSelected, categorisedBasedOn,
    title, viewReportButton, height, isSalesKey }) => {

    const allCategories = {}
    
    let salesBreakdownByDay = {};

    const reduceCallback = (acc, day) => {
        const date = moment(`${day.salesMonth}-${day?.day}-${day?.salesYear}`, 'MMM-D-YYYY');

        const dateWithMonthYear = date.format('D-MMM-YYYY-DDD');

        if (acc[dateWithMonthYear]) {
            acc?.[dateWithMonthYear]?.push(day)
        } else {
            acc[dateWithMonthYear] = [day]
        }

        if (day && !allCategories[day?.[categorisedBasedOn]]) {
            if (!day?.[categorisedBasedOn] || day?.[categorisedBasedOn] === 'null') {
                allCategories['N/A'] = 'N/A';
            } else {
                allCategories[day?.[categorisedBasedOn]] = day?.[categorisedBasedOn]
            }
        }


        return acc
    }
    salesBreakdownByDay = dataToShowForDatesSelected?.reduce(reduceCallback, {}) ?? {};
    const dataToPlot = Object.keys(salesBreakdownByDay).map((key) => {
        const daySalesArr = salesBreakdownByDay[key];
        const currentDayByCategory = {};
        const [day, month, year, dayofyear] = key.split('-');

        let totalAmount = 0
        daySalesArr?.forEach((item) => {
            if (item && currentDayByCategory[item?.[categorisedBasedOn]]) {
                currentDayByCategory[item?.[categorisedBasedOn]]?.push(item);
            } else if (item && (!item?.[categorisedBasedOn] || item?.[categorisedBasedOn] === 'null')) {
                if (currentDayByCategory['N/A']) {
                    currentDayByCategory['N/A']?.push(item)
                } else {
                    currentDayByCategory['N/A'] = [item]
                }
            } else {
                currentDayByCategory[item?.[categorisedBasedOn]] = [item]
            }
        });

        const currentMonthDataKey = `${day}, ${month} ${year}`;

        return Object.keys(currentDayByCategory).reduce((acc, categ) => {
            const amount = currentDayByCategory[categ]?.reduce((accum, item) => Number(Number(Number(accum) +
                Number(item?.[isSalesKey])).toFixed(2)), 0);
            totalAmount += amount;
            acc[categ] = amount;
            acc.Amount = totalAmount;
            acc.day = `${month}-${day}-${year}`;
            acc.currentMonthDataKey = currentMonthDataKey
            return acc
        }, {})
    })

    return (
        <>
            <div className="card__title">
                <h5 className="bold-text">{title}</h5>
                <div id='dvChartView'>
                    {viewReportButton?.()}</div>
            </div>
            {dataToPlot.length ? (<Row>
                <Col sm={12} md={12}>
                    <AreaBarGraph dir={dir}
                        totalDays={365}
                        dataToPlot={dataToPlot}
                        height={height}
                        showTitle={false}
                        categorisedBasedOn={categorisedBasedOn}
                        allCategories={allCategories}
                        isSalesKey={isSalesKey}
                    /></Col>
            </Row>
            ) : <div className="no-data">No data to display</div>}
        </>

    )
}

SalesBreakDownCategorised.propTypes = {
    dir: PropTypes.string.isRequired,
    dataToShowForDatesSelected: PropTypes.array.isRequired,
    title: PropTypes.string,
    viewReportButton: PropTypes.func.isRequired,
    categorisedBasedOn: PropTypes.string,
    height: PropTypes.number.isRequired,
    isSalesKey: PropTypes.string,
};

SalesBreakDownCategorised.defaultProps = {
    title: 'Sales Breakdown by category',
    categorisedBasedOn: 'productCategory',
    isSalesKey: 'amount'
}

export default SalesBreakDownCategorised;
